<template>
	<div>
		<h1 class="text-center">{{$t('user.forget.forgetpwd')}}</h1>
		<br />
		<div>
			<Input
				v-model="account"
				pre_icon="icon-yonghuming"
				:placeholder="$t('user.forget.inputphone')"
			/>
		</div>
		<div>
			<VerifyInput
				ref="verifyInput"
				pre_icon="icon-ziyuan"
				v-model="code"
				:placeholder="$t('user.forget.inputcode')"
				@sendCode="sendCode"
			/>
		</div>
		<div>
			<Input
				v-model="password"
				type="password"
				pre_icon="icon-mima"
				:placeholder="$t('user.forget.inputnew')"
			/>
		</div>
    <input hidden />
		<div>
			<button class="btn btn-blue" @click="toReset"  v-loading="loading">{{$t('user.forget.reset')}}</button>
		</div>
		<div class="between_line">
			<router-link class="btn" :to="{ name: 'login' }">{{$t('user.forget.login')}}</router-link>
			<div>
				{{$t('user.forget.noaccount')}}
				<router-link class="btn" :to="{ name: 'register' }"
					>{{$t('user.forget.register')}}</router-link
				>
			</div>
		</div>
	</div>
</template>
<script>
import { validatePass, is_email, is_Phone } from "@/utils/vaildate";
import { mapActions } from "vuex";
import { VerifyInput, Input } from "@/components";
export default {
	name: "forget",
	data() {
		return {
			account: "",
			password: "",
			code: "",
			loading: false
		};
	},
	components: {
		VerifyInput,
		Input,
	},
	computed: {
		isPhone() {
			return !is_email(this.account) && is_Phone(this.account);
		},
	},
	methods: {
		...mapActions("user", ["resetPassword", "sendSmsCode", "sendEmailCode"]),
		vaild() {
			const { account, password,code} = this;
			if (!is_email(account) && !is_Phone(account)) {
				this.$tooltip.warning(this.$t('user.forget.inputphone'));
				return false;
			}
			if (!password) {
				this.$tooltip.warning(this.$t('user.forget.pwd'));
				return false;
			}
			if (!validatePass(password)) {
				this.$tooltip.warning(this.$t('user.forget.correctpwd'));
				return false;
      }
      if (!code) {
				this.$tooltip.warning(this.$t('user.forget.inputcode'));
				return false;
			}
			return true;
		},
		async toReset() {
			if (!this.vaild()) return;
			try {
				this.loading = true
        const { account, password, code } = this;
        let eventName = "";
				if (is_Phone(account)) {
					eventName = "resetPasswordByPhoneCode";
				} else if (is_email(account)) {
					eventName = "resetPasswordByEmailCode";
				}
				const params = {
          p1: account,
          p2: code,
          p3: password
				};
				
				await this.resetPassword({ eventName, params});
        this.$tooltip.success(this.$t('user.forget.resetpwd'));
        this.$router.push({name:'login'})
				this.loading = false
			} catch (e) {
				this.$tooltip.error(e);
				this.loading = false
			}
		},
		async sendCode() {
			const { account } = this;
      let codeName = "";
      const params = {
        account: account
      }
			if (is_email(account)) {
        codeName = "sendEmailCode";
        params.scene = 'RESET_PASSWORD'
			} else if (is_Phone(account)) {
				codeName = "sendSmsCode";
			} else {
				this.$tooltip.warning(this.$t('user.forget.correctphone'));
			}
			if (!codeName) return;
			try {
				this.$refs.verifyInput.loading = true;
				await this[codeName](params);
				this.$refs.verifyInput.countDown();
				this.$refs.verifyInput.loading = false;
				this.$tooltip.success(this.$t('user.forget.success'));
			} catch (e) {
				this.$refs.verifyInput.loading = false;
				this.$tooltip.error(e);
			}
		},
		toLogin() {
			this.$router.push({ name: "login" });
		},
	},
};
</script>
<style lang="sass" scoped>
.between_line
  display: flex
  justify-content: space-between
  margin-top: .6rem
  .btn
    cursor: pointer
</style>
